import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const OrderGroupingDurationControl = ({
    value = 5,
    setValue,
    min = 1,
    max = 15,
}) => {
    return (
        <Box display="flex" alignItems="center" ml={2}>
            <Button
                variant="outlined"
                size="small"
                onClick={() => setValue(Math.max(min, value - 1))}
                disabled={value <= min}
                sx={{
                    minWidth: "30px",
                    padding: "0 8px",
                    marginRight: "8px",
                    color: "#455A64",
                    borderColor: "#455A64",
                    "&:hover": {
                        backgroundColor: "#455A64",
                        color: "#fff",
                    },
                }}
            >
                -
            </Button>
            <Typography
                variant="body1"
                sx={{ minWidth: "40px", textAlign: "center" }}
            >
                <span style={{ fontWeight: "bold" }}>{value}</span> min
            </Typography>
            <Button
                variant="outlined"
                size="small"
                onClick={() => setValue((Math.min(max, value + 1)))}
                disabled={value >= max}
                sx={{
                    minWidth: "30px",
                    padding: "0 8px",
                    marginLeft: "8px",
                    color: "#455A64",
                    borderColor: "#455A64",
                    "&:hover": {
                        backgroundColor: "#455A64",
                        color: "#fff",
                    },
                }}
            >
                +
            </Button>
        </Box>
    );
};

export default OrderGroupingDurationControl;